import paperLux from './papers/White Paper LuxTrace Services.pdf'
import paperWines from './papers/White Paper Wines.pdf'

const LUXTRACE = () => {
    return (
        <section id="portfolio-details" className="portfolio-details" style={{ marginTop: '5rem' }}>
            <div className="container">
                <div className="row gy-4">
                    <div className="col-lg-8">
                        <div className="portfolio-description">
                            <h2>LuxTrace Services</h2>
                            <p>
                                LuxTrace Services es una plataforma descentralizada diseñada para abordar los desafíos de trazabilidad y autenticidad en la industria del lujo. Basada en la tecnología blockchain, nuestra solución ofrece la oportunidad para que cada producto de lujo cuente su propia historia, registrando en la cadena de bloques información crucial sobre la vida del producto, como lugar de fabricación, certificados y historial de transporte.
                            </p>
                            <p>
                                Nuestra aplicación, adaptada a las necesidades individuales de cada cliente, permite a los usuarios acceder de manera eficiente a esta información, garantizando la integridad y autenticidad de cada producto. Utilizamos smart contracts para gestionar la transferencia de propiedad y registrar detalles específicos de cada artículo.
                            </p>
                            <p>
                                Este servicio puede ser aplicado tanto para relojes de lujo, prendas de ropa de lujo, como productos vinícolas, como la solución LuxTrace Wines.
                            </p>
                            <p>
                                Con un enfoque en la transparencia y la seguridad, LuxTrace Services proporciona una herramienta valiosa para combatir las falsificaciones y mantener los estándares de excelencia en la industria del lujo. Nuestra integración con tecnologías como Metamask asegura una experiencia de usuario segura y optimizada.
                            </p>
                            <p>
                                Si desea conocer más sobre el proyecto, consulte el white paper que encontrará disponible en esta misma página, así como un enlace a nuestra página web.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="portfolio-info">
                            <h3>Información del Proyecto</h3>
                            <ul>
                                <li><strong>Categoria</strong>: Web3, Blockchain</li>
                                <li><strong>White Paper LuxTrace Services</strong>: <a href={paperLux} download>LuxTrace Services</a></li>
                                <li><strong>White Paper LuxTrace Wines</strong>: <a href={paperWines} download>LuxTrace Wines</a></li>
                                <li><strong>Fecha de inicio</strong>: 3 de Julio, 2023</li>
                                <li><strong>Página web</strong>: <a href="https://moonlit-cupcake-717850.netlify.app/">Web de LuxTrace Services</a></li>
                                <li><strong>Github</strong>: <a href="https://github.com/MateuJP/Prototype-LuxTraceWatch">Prototype LuxTrace Watch</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LUXTRACE;
